// External Audit Data
export const externalAuditData = {
  2023: {
  opinion: { value: { pt: 'Sem Reservas', en: 'Unqualified' }, status: 'strong', trend: 'stable' },
  reservations: { value: 1, prevValue: 2, status: 'inline' },
  scopeLimitations: { value: 1, prevValue: 2, status: 'inline' },
  adjustments: { value: 450, unit: 'M AOA', prevValue: 520, status: 'inline' },
  remediation: { value: 52, unit: '%', prevValue: 45, status: 'attention' },
  pbcOnTime: { value: 68, unit: '%', prevValue: 62 },
  recurrence: { value: 55, unit: '%', prevValue: 60 },
  criticalThemes: [
    { category: { pt: 'Inventários / Stockpiles', en: 'Inventories / Stockpiles' }, severity: 'high', findings: { 2023: 5, 2024: 3, 2025: 4 }, status: 'open' },
    { category: { pt: 'Capitalização / Imobilizado', en: 'Capitalization / Fixed Assets' }, severity: 'medium', findings: { 2023: 3, 2024: 2, 2025: 3 }, status: 'partial' },
    { category: { pt: 'Fiscalidade', en: 'Taxation' }, severity: 'low', findings: { 2023: 2, 2024: 1, 2025: 2 }, status: 'partial' },
    { category: { pt: 'Relato Financeiro', en: 'Financial Reporting' }, severity: 'medium', findings: { 2023: 3, 2024: 2, 2025: 2 }, status: 'partial' },
    { category: { pt: 'Controlo Interno', en: 'Internal Control' }, severity: 'high', findings: { 2023: 6, 2024: 4, 2025: 5 }, status: 'open' },
    { category: { pt: 'Partes Relacionadas', en: 'Related Parties' }, severity: 'low', findings: { 2023: 2, 2024: 1, 2025: 2 }, status: 'partial' },
    { category: { pt: 'Continuidade', en: 'Going Concern' }, severity: 'low', findings: { 2023: 1, 2024: 0, 2025: 1 }, status: 'closed' },
  ],
  adjustmentsDetail: {
    proposed: 520,
    recorded: 450,
    notRecorded: 70,
    netImpact: -380,
  },
  remediationDetail: {
    closed: 35,
    inProgress: 30,
    pending: 35,
    total: 100,
  },
},
2024: {
  opinion: { value: { pt: 'Sem Reservas', en: 'Unqualified' }, status: 'strong', trend: 'stable' },
  reservations: { value: 0, prevValue: 1, status: 'strong' },
  scopeLimitations: { value: 0, prevValue: 1, status: 'strong' },
  adjustments: { value: 320, unit: 'M AOA', prevValue: 450, status: 'inline' },
  remediation: { value: 65, unit: '%', prevValue: 52, status: 'attention' },
  pbcOnTime: { value: 78, unit: '%', prevValue: 68 },
  recurrence: { value: 48, unit: '%', prevValue: 55 },
  criticalThemes: [
    { category: { pt: 'Inventários / Stockpiles', en: 'Inventories / Stockpiles' }, severity: 'high', findings: { 2023: 5, 2024: 3, 2025: 4 }, status: 'open' },
    { category: { pt: 'Capitalização / Imobilizado', en: 'Capitalization / Fixed Assets' }, severity: 'medium', findings: { 2023: 3, 2024: 2, 2025: 3 }, status: 'partial' },
    { category: { pt: 'Fiscalidade', en: 'Taxation' }, severity: 'low', findings: { 2023: 2, 2024: 1, 2025: 2 }, status: 'partial' },
    { category: { pt: 'Relato Financeiro', en: 'Financial Reporting' }, severity: 'medium', findings: { 2023: 3, 2024: 2, 2025: 2 }, status: 'partial' },
    { category: { pt: 'Controlo Interno', en: 'Internal Control' }, severity: 'high', findings: { 2023: 6, 2024: 4, 2025: 5 }, status: 'open' },
    { category: { pt: 'Partes Relacionadas', en: 'Related Parties' }, severity: 'low', findings: { 2023: 2, 2024: 1, 2025: 2 }, status: 'partial' },
    { category: { pt: 'Continuidade', en: 'Going Concern' }, severity: 'low', findings: { 2023: 1, 2024: 0, 2025: 1 }, status: 'closed' },
  ],
  adjustmentsDetail: {
    proposed: 450,
    recorded: 320,
    notRecorded: 130,
    netImpact: -285,
  },
  remediationDetail: {
    closed: 42,
    inProgress: 28,
    pending: 30,
    total: 100,
  },
},
2025: {
  opinion: { value: { pt: 'Com Reservas', en: 'Qualified' }, status: 'attention', trend: 'down' },
  reservations: { value: 2, prevValue: 0, status: 'attention' },
  scopeLimitations: { value: 1, prevValue: 0, status: 'attention' },
  adjustments: { value: 485, unit: 'M AOA', prevValue: 320, status: 'attention' },
  remediation: { value: 71, unit: '%', prevValue: 65, status: 'inline' },
  pbcOnTime: { value: 82, unit: '%', prevValue: 78 },
  recurrence: { value: 43, unit: '%', prevValue: 48 },
  criticalThemes: [
    { category: { pt: 'Existências / Stockpiles e saldos iniciais', en: 'Inventories / Stockpiles and opening balances' }, severity: 'high', findings: { 2023: 1, 2024: 1, 2025: 1 }, status: 'partial' },
    { category: { pt: 'Capitalização / Imobilizado / custos de desenvolvimento', en: 'Capitalization / Fixed Assets / development costs' }, severity: 'high', findings: { 2023: 1, 2024: 1, 2025: 1 }, status: 'partial' },
    { category: { pt: 'Provisão de reabilitação ambiental', en: 'Environmental rehabilitation provision' }, severity: 'high', findings: { 2023: 1, 2024: 1, 2025: 1 }, status: 'partial' },
    { category: { pt: 'Formalização histórica de activos e passivos', en: 'Historical formalization of assets and liabilities' }, severity: 'high', findings: { 2023: 1, 2024: 1, 2025: 1 }, status: 'open' },
    { category: { pt: 'Confirmações externas e reconciliações', en: 'External confirmations and reconciliations' }, severity: 'medium', findings: { 2023: 1, 2024: 1, 2025: 0 }, status: 'closed' },
    { category: { pt: 'Fecho histórico / aprovação de exercícios anteriores', en: 'Historical closing / approval of prior years' }, severity: 'medium', findings: { 2023: 1, 2024: 1, 2025: 0 }, status: 'closed' },
  ],
  adjustmentsDetail: {
    proposed: 620,
    recorded: 485,
    notRecorded: 135,
    netImpact: -412,
  },
  remediationDetail: {
    closed: 48,
    inProgress: 23,
    pending: 29,
    total: 100,
  },
},
2026: {
  opinion: { value: { pt: 'Sem Reservas', en: 'Unqualified' }, status: 'strong', trend: 'up' },
  reservations: { value: 0, prevValue: 2, status: 'strong' },
  scopeLimitations: { value: 0, prevValue: 1, status: 'strong' },
  adjustments: { value: 285, unit: 'M AOA', prevValue: 485, status: 'strong' },
  remediation: { value: 84, unit: '%', prevValue: 71, status: 'strong' },
  pbcOnTime: { value: 91, unit: '%', prevValue: 82 },
  recurrence: { value: 28, unit: '%', prevValue: 43 },
  criticalThemes: [
    { category: { pt: 'Inventários / Stockpiles', en: 'Inventories / Stockpiles' }, severity: 'medium', findings: { 2023: 5, 2024: 3, 2025: 4 }, status: 'partial' },
    { category: { pt: 'Capitalização / Imobilizado', en: 'Capitalization / Fixed Assets' }, severity: 'low', findings: { 2023: 3, 2024: 2, 2025: 3 }, status: 'closed' },
    { category: { pt: 'Fiscalidade', en: 'Taxation' }, severity: 'low', findings: { 2023: 2, 2024: 1, 2025: 2 }, status: 'closed' },
    { category: { pt: 'Relato Financeiro', en: 'Financial Reporting' }, severity: 'low', findings: { 2023: 3, 2024: 2, 2025: 2 }, status: 'closed' },
    { category: { pt: 'Controlo Interno', en: 'Internal Control' }, severity: 'medium', findings: { 2023: 6, 2024: 4, 2025: 5 }, status: 'partial' },
    { category: { pt: 'Partes Relacionadas', en: 'Related Parties' }, severity: 'low', findings: { 2023: 2, 2024: 1, 2025: 2 }, status: 'closed' },
    { category: { pt: 'Continuidade', en: 'Going Concern' }, severity: 'low', findings: { 2023: 1, 2024: 0, 2025: 1 }, status: 'closed' },
  ],
  adjustmentsDetail: {
    proposed: 380,
    recorded: 285,
    notRecorded: 95,
    netImpact: -215,
  },
  remediationDetail: {
    closed: 62,
    inProgress: 22,
    pending: 16,
    total: 100,
  },
},
};
